import React, { useEffect } from 'react';
import { Container, Row, Col, Tab} from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/service.js';
import { useTranslation } from 'react-i18next';

function Services() {
    const { t } = useTranslation();
    useEffect(() => {
        const courseButton = document.querySelectorAll(".course-button");
        courseButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (button.classList.contains("active")) {
                    content.className = "course-content show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "course-content";
                    content.style.maxHeight = "0";
                }
            });
        });
    });

    return (
        <div className="main-wrapper course-details-page" >

            {/* Header 2 */}
            < HeaderTwo />

            <Styles>
                {/* Course Details */}
                <section className="course-details-area">
                    <Container>
                        <Row>
                            <Col lg="9" md="8" sm="12">
                                <div className="course-details-top">
                                    <div className="course-tab-list">
                                        <Tab.Container defaultActiveKey="overview">
                                            <Tab.Content>
                                                <Tab.Pane eventKey="overview" className="overview-tab">
                                                    <div className="course-learn">
                                                        <h4>{t('services_page.title')}</h4>
                                                        <p>{t('services_page.p1')}</p>
                                                        <ul className="list-unstyled">
                                                            <li><i className="fa fa-check"></i> <span>{t('home.services.list.0.title')}: </span>{t('home.services.list.0.subtitle')}</li>
                                                            <li><i className="fa fa-check"></i> <span>{t('home.services.list.1.title')}: </span>{t('home.services.list.1.subtitle')}</li>
                                                            <li><i className="fa fa-check"></i> <span>{t('home.services.list.2.title')}: </span>{t('home.services.list.2.subtitle')}</li>
                                                            <li><i className="fa fa-check"></i> <span>{t('home.services.list.3.title')}: </span>{t('home.services.list.3.subtitle')}</li>
                                                        </ul>
                                                    </div>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Tab.Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>

            {/* Footer 2 */}
            <FooterTwo />

        </div >
    )
}

export default Services